import PigsStaticTemplateImage from 'style/imgs/mapTemplate/pigs/static-template.png';
import PigsLinearTemplateImage from 'style/imgs/mapTemplate/pigs/linear-template.png';
import PigsDigitalTemplateImage from 'style/imgs/mapTemplate/pigs/digital-preview.png';

import FantasyLandStaticTemplateImage from 'style/imgs/mapTemplate/fantasy-land/fantasy-land-static-template.png';
import FantasyLandLinearTemplateImage from 'style/imgs/mapTemplate/fantasy-land/fantasy-land-linear-template.png';
import FantasyLandDigitalTemplateImage from 'style/imgs/mapTemplate/fantasy-land/digital-preview.png';

import UnderseaStaticTemplateImage from 'style/imgs/mapTemplate/undersea/undersea-static-template.png';
import UnderseaLinearTemplateImage from 'style/imgs/mapTemplate/undersea/undersea-linear-template.png';
import UnderseaDigitalTemplateImage from 'style/imgs/mapTemplate/undersea/digital-preview.png';

import FutureCityStaticTemplateImage from 'style/imgs/mapTemplate/future-city/future-city-static-template.png';
import FutureCityLinearTemplateImage from 'style/imgs/mapTemplate/future-city/future-city-linear-template.png';
import FutureCityDigitalTemplateImage from 'style/imgs/mapTemplate/future-city/digital-preview.png';
import { MapTemplate, MapType } from 'types';

export default function getMapTemplateImage(
  mapStyle: MapTemplate,
  mapType: MapType
): string {
  switch (mapStyle) {
    case MapTemplate.littlePigs:
      if (mapType === MapType.Static) {
        return PigsStaticTemplateImage;
      }
      if (mapType === MapType.Linear) {
        return PigsLinearTemplateImage;
      }
      return PigsDigitalTemplateImage;
    case MapTemplate.fantasyLand:
      if (mapType === MapType.Static) {
        return FantasyLandStaticTemplateImage;
      }
      if (mapType === MapType.Linear) {
        return FantasyLandLinearTemplateImage;
      }
      return FantasyLandDigitalTemplateImage;
    case MapTemplate.undersea:
      if (mapType === MapType.Static) {
        return UnderseaStaticTemplateImage;
      }
      if (mapType === MapType.Linear) {
        return UnderseaLinearTemplateImage;
      }
      return UnderseaDigitalTemplateImage;
    case MapTemplate.futureCity:
      if (mapType === MapType.Static) {
        return FutureCityStaticTemplateImage;
      }
      if (mapType === MapType.Linear) {
        return FutureCityLinearTemplateImage;
      }
      return FutureCityDigitalTemplateImage;
    default:
      if (mapType === MapType.Static) {
        return PigsStaticTemplateImage;
      }
      if (mapType === MapType.Linear) {
        return PigsLinearTemplateImage;
      }
      return PigsDigitalTemplateImage;
  }
}
